export default __webpack_public_path__ + "static/media/how-people.9f3d0325.jpg";